import { Suspense, lazy } from 'react';
import { Layout, Loader } from '../components';
import { useRoutes } from 'react-router-dom';
import GuestGuard from './Guards/GuestGuard';
import AuthenticatedLayout from './Authenticated.layout';
import CouponCodeComponent from '../components/CouponCodeComponent/CouponCodeComponent';
import RewardComponent from '../components/RewardComponent/RewardComponent';
const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};
const Login = Loadable(lazy(() => import('./Login/Login')));
const Page404 = Loadable(lazy(() => import('./Page404/Page404')));
export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <GuestGuard />,
      children: [
        { path: 'login', element: <Login /> },
        // { path: 'online-register', element: <VisitorRegisterOnline /> },
      ],
    },
    {
      element: <AuthenticatedLayout />,
      children: [
        {
          element: (
            <Layout>
              <CouponCodeComponent />
            </Layout>
          ),
          index: true,
        },
        {
          path: 'reward/list',
          element: (
            <Layout>
              <RewardComponent />
            </Layout>
          ),
        },
      ],
    },
    { path: '*', element: <Page404 /> },
  ]);
}
